import { useRouter } from 'next/router'
import React from 'react'

import { EmptyState, EmptyStateAction } from 'components/EmptyState'

const QueryNotCompleteError = ({
  isDesktop = false,
}: {
  isDesktop?: boolean
}) => {
  const { replace } = useRouter()
  return (
    <EmptyState
      title="Halaman tidak ditemukan"
      description="Halaman yang anda cari tidak dapat ditemukan, silakan tekan tombol dibawah untuk kembali ke daftar topik"
      fullscreen={!isDesktop}
      className={isDesktop ? 'min-h-[320px]' : undefined}
    >
      <EmptyStateAction
        className={isDesktop ? 'mb-4 max-w-sm' : undefined}
        onClick={() =>
          replace(
            `/${
              process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
              'pelatihan-mandiri'
            }`
          )
        }
      >
        Kembali ke Daftar Topik
      </EmptyStateAction>
    </EmptyState>
  )
}

export default QueryNotCompleteError
